module.exports = __webpack_public_path__ + "img/container_storage.a6a47086.jpg";